/**
 * Global CSS Styles
 * Applied via MUI's <GlobalStyles> component at the app root.
 * Configures root layout, custom scrollbar styling (Sage brand),
 * and keyboard focus-visible outlines for accessibility.
 */

import { grey } from "@mui/material/colors";

import { pxToRem } from "@constants/theme.config";
import { fontFamilyConstants, NonMuiColors } from "@constants/theme.constants";

const globalCssStyles = {
  body: {
    margin: 0,
    padding: 0
  },
  ":root": {
    "--sage-font": fontFamilyConstants.SAGE_UI_ADAPTIVE
  },
  "#root": {
    height: "100vh",
    width: "100vw",
    overflow: "hidden",
    fontFamily: "var(--sage-font)",
    display: "flex",
    flexDirection: "column"
  },
  "#root-portal": {
    position: "fixed",
    inset: 0,
    zIndex: 1500,
    pointerEvents: "none",
    overflow: "visible"
  },
  "#root-portal > *": {
    pointerEvents: "auto"
  },
  "#root-portal .react-datepicker-popper": {
    zIndex: 1500
  },
  "#root-portal .edit-effective-date-popper": {
    right: 0,
    left: "auto !important",
    transform: "translate(0, 0) !important"
  },
  "#root-portal .react-datepicker": {
    maxHeight: "calc(100vh - 20px)",
    overflowY: "auto"
  },
  "*::-webkit-scrollbar-track": {
    borderRadius: pxToRem(2),
    backgroundColor: "transparent"
  },
  "*::-webkit-scrollbar": {
    width: pxToRem(14),
    height: pxToRem(14),
    backgroundColor: "transparent"
  },
  "*::-webkit-scrollbar-thumb": {
    border: `${pxToRem(4)} solid transparent`,
    backgroundClip: "padding-box",
    borderRadius: pxToRem(6),
    backgroundColor: grey[400]
  },
  "*:focus-visible": {
    outline: `${pxToRem(2)} solid ${NonMuiColors.FOCUS_VISIBLE_COLOR}`
  }
};

export default globalCssStyles;
